module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/HowToBackground-143de910e2120338f13d7f970b0d09ba.webp";